var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdRestart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2903 4.29688C2.87714 5.74549 2 7.76024 2 9.9748C2 12.1894 2.87714 14.2041 4.2903 15.6527C5.70346 17.1013 7.6689 18.0005 9.82925 18.0005C11.9896 18.0005 13.955 17.1013 15.3682 15.6527C16.7814 14.2041 17.6585 12.1894 17.6585 9.9748C17.6585 7.76024 16.7814 5.74549 15.3682 4.29688",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8457 10.2007V2",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V3.51569C14 3.22422 14.2232 3 14.5134 3H18.5",
    stroke: "#455079",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdRestart);
export default __webpack_public_path__ + "static/media/cmd-restart.00bf2ce6a3105a33057401125086006a.svg";
export { ForwardRef as ReactComponent };